import React,{ Component } from 'react';

class SocialList extends Component {
    constructor(props) {
        super(props);
        const data = props.color;
        this.state = {
            color: data
        }
    }
    render() {
        const list = {
            position: 'absolute',
            top: '40px',
            right: '30px',
            display: 'flex',
            flexDirection: 'row-reverse',
            zIndex: '1000',
        }

        const icon = {
            margin: 'auto 15px',
            color: this.state.color,
        }
        return (
            <div style={list}>
                <a href="https://www.facebook.com/NME.company" target="_blank" rel="noopener noreferrer" style={icon}><i className="fa fa-facebook fa-lg"></i></a>
                <a href="https://www.youtube.com/channel/UCE8HC9gJh8qieAkqGu1thBQ" rel="noopener noreferrer" target="_blank" style={icon}><i className="fa fa-youtube-play fa-lg"></i></a>
                <a href="https://www.instagram.com/nme.company/" target="_blank" rel="noopener noreferrer" style={icon}><i className="fa fa-instagram fa-lg"></i></a>
                <a href="https://www.linkedin.com/company-beta/13310420/" target="_blank" rel="noopener noreferrer" style={icon}><i className="fa fa-linkedin fa-lg"></i></a>
            </div>
        );
    }
};

export default SocialList;



// WEBPACK FOOTER //
// ./src/components/social-list.js